<script setup>

const emit = defineEmits([
  'tag:remove',
])

const { tagLabel, readOnly } = defineProps({
  tagLabel: String,
  readOnly: {
    type: Boolean,
    default: false,
  },
})

const onClick = () => {
  emit('tag:remove', tagLabel)
}


</script>

<template>
  <div class="tag-cont">
    <div class="tag-text">
      <span>{{tagLabel}}</span>
      <span v-if="!readOnly" class="material-symbols-outlined" @click="onClick">close</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@Common/styles/tag";
</style>
